import BackgroundImage from "@components/BackgroundImageCst";
import { Container, Grid } from "@mui/material";
import CardHomeCst from "@components/CardHomeCst";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Breadcrumb";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";
import { useAuth } from "@context/auth";
import HeroCst from "@components/HeroCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";

const DashboardPage: React.FC = () => {
  const { t } = useTranslation(["dashboard-digited-page", "common"]);
  const { user } = useAuth();
  useResetFilters();

  const dashboardSection = [
    "smartconfigurator.quicksight.import.dashboards",
    "smartconfigurator.quicksight.associate.corporates",
  ];

  const menuItem = useMenu();
  const navigation = useNavigaionRoutes();

  let dashboardMenu = [];
  if (menuItem.length > 0) {
    dashboardMenu = navigation
      .find((el) => el.to === "dashboard")
      ?.children?.filter((el: { section: string }) => {
        return (
          user?.permissions?.includes(el.section) &&
          dashboardSection?.includes(el.section)
        );
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-dashboard.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <Grid container spacing={3}>
          {dashboardMenu.length > 0 &&
            dashboardMenu.map(
              (
                { image, to, disabled, text, buttonLabel, description }: any,
                index: React.Key | null | undefined,
              ) => (
                <Grid key={index} item xs={12} md={6} lg={4}>
                  <CardHomeCst
                    image={image}
                    title={text}
                    description={description}
                    secondaryBtnLabel={buttonLabel}
                    to={to}
                    disabled={disabled}
                  />
                </Grid>
              ),
            )}
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default DashboardPage;
